import { dataEnvelopeOpen } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnvelopeOpen = /*#__PURE__*/createIcon(dataEnvelopeOpen)
export default IconEnvelopeOpen
